/**
 * StreamingCursor — thin blinking line shown while TERRA is streaming.
 */
export function StreamingCursor() {
  return (
    <span className="inline-block w-0.5 h-4 bg-cyan-400 animate-blink ml-0.5 align-text-bottom" />
  );
}
